import React, { useState } from 'react';
import './Topbar.css';

const Topbar = ({ onLogout, username, userRole, onMenuToggle }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const notifications = [
    { id: 1, text: 'New claim submitted by John Doe', time: '5 min ago', unread: true },
    { id: 2, text: 'Policy renewal reminder for 3 clients', time: '1 hour ago', unread: true },
    { id: 3, text: 'Monthly report is ready', time: '2 hours ago', unread: false },
    { id: 4, text: 'New client registered', time: '1 day ago', unread: false }
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="hamburger-menu" onClick={onMenuToggle}>
          <span className="icon">☰</span>
        </button>
        <h2 className="page-title">
          {userRole === 1 ? 'Dashboard' : 'Policy Management'}
        </h2>
      </div>

      <div className="topbar-right">
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input type="text" placeholder="Search..." />
        </div>

        <div className="topbar-item notifications-container">
          <button 
            className="icon-button"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowSettings(false);
            }}
          >
            <span className="icon">🔔</span>
            {unreadCount > 0 && (
              <span className="badge">{unreadCount}</span>
            )}
          </button>

          {showNotifications && (
            <div className="dropdown notifications-dropdown">
              <div className="dropdown-header">
                <h3>Notifications</h3>
                <button className="mark-read-btn">Mark all as read</button>
              </div>
              <div className="dropdown-body">
                {notifications.map(notif => (
                  <div 
                    key={notif.id} 
                    className={`notification-item ${notif.unread ? 'unread' : ''}`}
                  >
                    <div className="notification-content">
                      <p>{notif.text}</p>
                      <span className="notification-time">{notif.time}</span>
                    </div>
                    {notif.unread && <span className="unread-dot"></span>}
                  </div>
                ))}
              </div>
              <div className="dropdown-footer">
                <a href="#all-notifications">View all notifications</a>
              </div>
            </div>
          )}
        </div>

        <div className="topbar-item settings-container">
          <button 
            className="icon-button"
            onClick={() => {
              setShowSettings(!showSettings);
              setShowNotifications(false);
            }}
          >
            <span className="icon">⚙️</span>
          </button>

          {showSettings && (
            <div className="dropdown settings-dropdown">
              <div className="dropdown-header">
                <h3>Settings</h3>
              </div>
              <div className="dropdown-body">
                <div className="settings-item">
                  <span className="settings-icon">👤</span>
                  <span>Profile</span>
                </div>
                <div className="settings-item">
                  <span className="settings-icon">🔒</span>
                  <span>Privacy</span>
                </div>
                <div className="settings-item">
                  <span className="settings-icon">🎨</span>
                  <span>Appearance</span>
                </div>
                <div className="settings-item">
                  <span className="settings-icon">📱</span>
                  <span>Notifications</span>
                </div>
                <div className="settings-divider"></div>
                <div className="settings-item logout" onClick={onLogout}>
                  <span className="settings-icon">🚪</span>
                  <span>Logout</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="user-info-topbar">
          <div className="user-avatar-small">👤</div>
          <div className="user-details">
            <span className="user-name-small">{username || 'User'}</span>
            <span className="user-role-small">{userRole === 1 ? 'Admin' : 'Policy Manager'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
